import * as React from 'react';
import {Helmet} from 'react-helmet';

import {colors} from 'shells/colors/colors';
import {headTitle} from 'shells/document/head-title';
import {PreAuthLayout} from 'shells/layout/pre-auth-layout';
import {Link} from 'shells/link/link';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

export function ExpiredPage() {
    return (
        <PreAuthLayout
            backgroundColor={colors.navyLt}
            imageLeft={<img alt='' src='/include/images/auth/expired.svg' />}
        >
            <Helmet>
                <title>{headTitle('Trial expired')}</title>
            </Helmet>
            <div>
                <Header>We just hate goodbyes. 😭</Header>
                <Subheader as='p'>
                    Your Nutshell trial has expired, but we’d love for you to stick around! Want to
                    make our CRM part of your daily life? Please have an administrator log in and
                    purchase a{' '}
                    <Link href='https://www.nutshell.com/pricing/' variant='primary' size='big'>
                        plan
                    </Link>
                    .
                </Subheader>
                <Subheader as='p'>
                    <Link href='https://support.nutshell.com/' variant='primary' size='big'>
                        Contact Nutshell support
                    </Link>{' '}
                    for additional billing options or for information on an extended trial period.
                </Subheader>
            </div>
        </PreAuthLayout>
    );
}
